export enum Op {
    EQ = 'EQ',
    IN = 'IN',
    OVERLAPS = 'OVERLAPS',
    NOTEXISTS = 'NOTEXISTS',
    EXISTS = 'EXISTS',
    LT = 'LT',
    LTEQ = 'LTEQ',
    GT = 'GT',
    GTEQ = 'GTEQ',
    NE = 'NE',
    LIKE = 'LIKE',
    CONTAINED_IN = 'CONTAINED_IN',
    NOTIN = 'NOTIN',
    NOTCONTAINED_IN = 'NOTCONTAINED_IN',
    NOTLIKE = 'NOTLIKE'
}
